import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Config } from "../../config";
import { getUrlSettings } from "./ApiService";

const URLRedirection: React.FC = () => {
  const { id: keyName } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const config = new Config();
  const domainOrigin = window.location.origin;
  //const domainOrigin = "testai.connectsform.com";

  useEffect(() => {
    if (!keyName) {
      navigate("*");
      return;
    }

    const fetchUrlSettings = async () => {
      try {
        const response = await getUrlSettings(keyName, domainOrigin);

        if (response?.valueItem) {
          const relativePath = response.valueItem.replace(config.settings.AppUrl, "");
          const targetPath = relativePath.includes("?")
            ? relativePath
            : `${relativePath}${location.search || ""}`;
          navigate(targetPath, { replace: true }); // Maintain SPA behavior
        } else {
          navigate("*");
        }
      } catch (error) {
        console.error(`Failed to fetch URL settings: ${error}`);
        navigate("*");
      }
    };

    fetchUrlSettings();
  }, [keyName, location.search]);

  return null;
};

export default URLRedirection;
